export const SEATTLE_RUN_CLUB_DATA = [

  {
    id: "fleet-feet-seattle",
    title: "Fleet Feet Run Crew",
    description: "Tuesday fun run.",
    subtitle: "Seattle",
    img: require('../../images/seattle/fleetfeetseattle.jpg'),
    categories: ["Social", "Evening","Free"],
    day: ["Tuesday"],
    daysOfWeek: ["Tuesday"],
    city: "Seattle", // Added city
  },

  {
    id: "csrd",
    title: "Club Seattle Runners Division",
    description: "All paces, all faces since 2017.",
    subtitle: "Seattle",
    img: require('../../images/seattle/csrd.jpg'),
    categories: ["Social", "Evening","Free"],
    day: ["Monday", "Saturday"],
    daysOfWeek: ["Monday", "Saturday"],
    city: "Seattle", // Added city
  },


  {
    id: "frelard",
    title: "Frelard Run Club",
    description: "Local breweries and running.",
    subtitle: "Seattle",
    img: require('../../images/seattle/frelard.jpg'),
    categories: ["Social", "Evening","Free"],    //TODO: Check if this is correct
    day: ["Thursday"],
    daysOfWeek: ["Thursday"],
    city: "Seattle", // Added city
  }
]